import {BaseAppPrefs} from "@/shared/BaseAppPrefs";

export class AppPrefs extends BaseAppPrefs {

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  private constructor() {
    super();
  }

  static readonly PREF_ASKWYZE_TERMS_ACCEPTED = "askwyze_terms_accepted";

  getAskWyzeTermsAccepted(): boolean {
    return this.prefs.getBoolean(AppPrefs.PREF_ASKWYZE_TERMS_ACCEPTED);
  }

  setAskWyzeTermsAccepted(accepted: boolean): void {
    this.prefs.setBoolean(AppPrefs.PREF_ASKWYZE_TERMS_ACCEPTED, accepted);
  }
}
